import { Record } from 'immutable';

export const Lottery = new Record({
  phone_number: null,
  createAt: null,
  status: null,
});



// WEBPACK FOOTER //
// ./src/core/lotteries/lottery.js